(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('DocumentoNorma', DocumentoNorma);

    DocumentoNorma.$inject = ['$resource'];

    function DocumentoNorma ($resource) {
        var resourceUrl =  'api/documentos/norma/:id';

        return $resource(resourceUrl, {}, {
            
            'get': {
                method: 'GET',isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }
})();
